module.exports = __webpack_public_path__ + "media/images/coupon/img-nomtok-8dbb41f0b6127d65d9119b6a32b91a00.png";